import { render } from "./ProductBoxWideSegmentConversion.vue?vue&type=template&id=5b5f4060&ts=true"
import script from "./ProductBoxWideSegmentConversion.vue?vue&type=script&lang=ts"
export * from "./ProductBoxWideSegmentConversion.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__